import HttpService from '../../services/HttpService';
import ErrorSwitchCase from '../../services/ErrorHandlerService';
import { ADMIN_PATH, PROJECT_PATH } from '../../url';
const _axios = HttpService.getAxiosClient();

export const applyWfhQuota = async (payload) => {
  try {
    const response = await _axios.put(`${ADMIN_PATH}/wfh-quota`, payload);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const applyExternalQuota = async (payload) => {
  try {
    const response = await _axios.put(
      `${ADMIN_PATH}/external-hours-quota`,
      payload,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getUsersExternalQuota = async (
  tenantId,
  year,
  pageSize,
  pageNumber,
  searchString,
) => {
  try {
    const response = await _axios.get(
      `${ADMIN_PATH}/users/external-hours-quota?${
        tenantId ? 'tenantId=' + tenantId + '&' : ''
      }${pageSize ? 'pageSize=' + pageSize + '&' : ''}${
        pageNumber >= 0 ? 'pageNumber=' + pageNumber + '&' : ''
      }${searchString ? 'searchString=' + searchString + '&' : ''}${
        year ? 'year=' + year : ''
      }`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getWfhQuota = async (
  tenantId,
  year,
  pageSize,
  pageNumber,
  searchString,
) => {
  try {
    const response = await _axios.get(
      `${ADMIN_PATH}/users/wfh-quota?${
        tenantId ? 'tenantId=' + tenantId + '&' : ''
      }${pageSize ? 'pageSize=' + pageSize + '&' : ''}${
        pageNumber >= 0 ? 'pageNumber=' + pageNumber + '&' : ''
      }${searchString ? 'searchString=' + searchString + '&' : ''}${
        year ? 'year=' + year : ''
      }`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getEmployeeWfhQuota = async (year, employeeId) => {
  try {
    const response = await _axios.get(
      `${ADMIN_PATH}/user/wfh-quota?${year ? 'year=' + year + '&' : ''}${
        employeeId ? 'employeeId=' + employeeId : ''
      }`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getEmployeeExternalHoursQuota = async (year, employeeId) => {
  try {
    const response = await _axios.get(
      `${ADMIN_PATH}/user/external-hours-quota?${year ? 'year=' + year + '&' : ''}${
        employeeId ? 'employeeId=' + employeeId : ''
      }`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getExternalQuotaForUser = async (employeeId, year) => {
  try {
    const response = await _axios.get(
      `${ADMIN_PATH}/user/external-hours-quota?${year ? 'year=' + year : ''}&${employeeId ? 'employeeId=' + employeeId : ''}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const applyClientOfficeQuota = async (payload) => {
  try {
    const response = await _axios.put(
      `${ADMIN_PATH}/client-office-hours-quota`,
      payload,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getUsersClientOfficeQuota = async (
  tenantId,
  year,
  pageSize,
  pageNumber,
  searchString,
) => {
  try {
    const response = await _axios.get(
      `${ADMIN_PATH}/users/client-office-hours-quota?${
        tenantId ? 'tenantId=' + tenantId + '&' : ''
      }${pageSize ? 'pageSize=' + pageSize + '&' : ''}${
        pageNumber >= 0 ? 'pageNumber=' + pageNumber + '&' : ''
      }${searchString ? 'searchString=' + searchString + '&' : ''}${
        year ? 'year=' + year : ''
      }`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getEmployeeClientOfficeHoursQuota = async (year, employeeId) => {
  try {
    const response = await _axios.get(
      `${ADMIN_PATH}/user/client-office-hours-quota?${year ? 'year=' + year + '&' : ''}${
        employeeId ? 'employeeId=' + employeeId : ''
      }`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getClientOfficeQuotaForUser = async (employeeId, year) => {
  try {
    const response = await _axios.get(
      `${ADMIN_PATH}/user/client-office-hours-quota?${year ? 'year=' + year : ''}&${employeeId ? 'employeeId=' + employeeId : ''}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const applyWorkTravelQuota = async (payload) => {
  try {
    const response = await _axios.put(
      `${ADMIN_PATH}/work-travel-hours-quota`,
      payload,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getUsersWorkTravelQuota = async (
  tenantId,
  year,
  pageSize,
  pageNumber,
  searchString,
) => {
  try {
    const response = await _axios.get(
      `${ADMIN_PATH}/users/work-travel-hours-quota?${
        tenantId ? 'tenantId=' + tenantId + '&' : ''
      }${pageSize ? 'pageSize=' + pageSize + '&' : ''}${
        pageNumber >= 0 ? 'pageNumber=' + pageNumber + '&' : ''
      }${searchString ? 'searchString=' + searchString + '&' : ''}${
        year ? 'year=' + year : ''
      }`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getEmployeeWorkTravelHoursQuota = async (year, employeeId) => {
  try {
    const response = await _axios.get(
      `${ADMIN_PATH}/user/work-travel-hours-quota?${year ? 'year=' + year + '&' : ''}${
        employeeId ? 'employeeId=' + employeeId : ''
      }`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getWorkTravelQuotaForUser = async (employeeId, year) => {
  try {
    const response = await _axios.get(
      `${ADMIN_PATH}/user/work-travel-hours-quota?${year ? 'year=' + year : ''}&${employeeId ? 'employeeId=' + employeeId : ''}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const applyLeaveQuota = async (payload) => {
  try {
    const response = await _axios.put(
      `${ADMIN_PATH}/leave-quota?${payload.employeeId ? 'employeeId=' + payload.employeeId + '&' : ''}${payload.leaveId ? 'leaveId=' + payload.leaveId + '&' : ''}${payload.noOfDays ? 'noOfDays=' + payload.noOfDays + '&' : ''}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getLeaveType = async (tenantId, year) => {
  try {
    const response = await _axios.get(
      `${PROJECT_PATH}/leave-type?tenantId=${tenantId}&year=${year}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getLeaveQuota = async (
  year,
  pageSize,
  pageNumber,
  searchString,
) => {
  try {
    const response = await _axios.get(
      `${ADMIN_PATH}/leave-quota?${year ? 'year=' + year + '&' : ''}${
        pageSize ? 'pageSize=' + pageSize + '&' : ''
      }${pageNumber >= 0 ? 'pageNumber=' + pageNumber + '&' : ''}${
        searchString ? 'searchString=' + searchString + '&' : ''
      }`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};
